export default {
    dashboard: {
        actions: 0,
        messages: 0,
        ...(window.frm.state.counters?.dashboard || {}),
    },
    fysioroadmap: {
        actions: 0,
        messages: 0,
        pgo_documents: 0,
        ...(window.frm.state.counters?.fysioroadmap || {}),
    },
};
